import { ICol, IGridConfig, IRendererConfig } from "./../types";

function normalizeArray(obj: any, name: string) {
	if (!obj[name]) {
		return;
	}
	if (typeof obj[name] === "string") {
		obj[name] = [{
			text: `${obj[name]}`
		}];
	} else {
		obj[name] = obj[name].map(el => {
			if (typeof el === "string") {
				el = { text: el } as any;
			}
			return el;
		});
	}
}
export function normalizeColumns(columns: ICol[]) {
	for (const col of columns) {
		col.$cellCss = col.$cellCss || {};
		normalizeArray(col, "header");
		normalizeArray(col, "footer");
		const isContent = col.header.reduce((acc, item) => acc = acc || !!item.content, false);
		if (isContent) {
			col.$uniqueData = [];
		}
		col.width = col.width || 100;
		if (col.width < col.minWidth) {
			col.width = col.minWidth;
		}
		if (col.width > col.maxWidth) {
			col.width = col.maxWidth;
		}
	}
}
export function countColumns(config: IGridConfig, columns: ICol[]): number {
	let headerRowsCount = 0;
	let footerRowsCount = 0;
	let totalWidth = 0;
	let colspans = false;
	let rowsHeadersCount = 0;
	let footer = false;
	columns.map(col => {
		headerRowsCount = Math.max(headerRowsCount, col.header.length);
		totalWidth += col.hidden ? 0 : col.width;

		if (col.footer) {
			footerRowsCount = Math.max(footerRowsCount, col.footer.length);
			if (!footer) {
				footer = true;
			}
		}

		if (!colspans) {
			for (const head of col.header) {
				if (head.colspan) {
					colspans = true;
					return;
				}
			}
		}
	});

	// fill missing cells
	columns.map(col => {
		if (col.header.length < headerRowsCount) {
			for (let i = 0;i < headerRowsCount;i++) {
				col.header[i] = col.header[i] || { text: "" };
			}
		}
		if (footer) {
			col.footer = col.footer || [];
		}
		if (col.footer && col.footer.length < footerRowsCount) {
			for (let i = 0;i < footerRowsCount;i++) {
				col.footer[i] = col.footer[i] || { text: "" };
			}
		}
		col.header.map(head => {
			head.css = head.css || "";
			if (!head.text && !/dhx_cell-empty/.test(head.css)) {
				head.css += " dhx_cell-empty";
			}
		});

		// find header columns indexes
		if (col.header[0].text === "") {
			rowsHeadersCount++;
		}
	});
	config.$totalWidth = totalWidth;
	config.$headerLevel = headerRowsCount;
	config.$footerLevel = footerRowsCount;
	config.$colspans = colspans;
	config.$footer = footer;
	return rowsHeadersCount;
}

export function calculatePositions(width: number, height: number, scroll: any, conf: IRendererConfig) {

	const avrColWidth = conf.$totalWidth / conf.columns.length;

	const colPerPage = Math.round(width / avrColWidth);
	const rowPerPage = Math.round(height / conf.rowHeight);

	const reserve = 1;
	const y = Math.round(scroll.top / conf.rowHeight) || 0;
	const yStart = y - reserve >= 0 ? y - reserve : 0;

	const yEnd = y + rowPerPage + reserve;
	let x = 0;
	let scrollLeft = scroll.left;
	for (let i = 0;i < conf.columns.length;i++) {
		const col = conf.columns[i];
		scrollLeft = scrollLeft - col.width;

		if (scrollLeft + (avrColWidth / 2) > 0) {
			x++;
		} else {
			break;
		}
	}
	const xStart = x - reserve >= 0 ? x - reserve : 0;
	const xEnd = x + colPerPage + reserve;

	return {
		xStart,
		xEnd,
		yStart,
		yEnd
	};
}
export function getUnique(arr: any[], name: string): any[] {
	return arr.map(item => item[name])
		.filter((item, i, array) => array.indexOf(item) === i)
		.sort();
}